import React from 'react';
import { AgencyLogo, AgencyAddress } from '../..';
import * as styles from './agency-details-sticky.style';
import { HERO_SECTION, PROFILE_TIERS } from '../../../constants';
import AverageStarRatingAndTotal, {
  STAR_RATING_SECTION,
} from '../../../../shared/average-star-rating-and-total';
import { OverallStarRating } from '../../../../shared/recommendations/types';

export type Props = {
  profileTier: PROFILE_TIERS;
  agencyName: string;
  agencyUrl: string;
  imageUrl: string;
  address: string;
  isActive?: boolean;
  isAgency?: boolean;
  hideOfficeLocation?: boolean;
  onAgencyAddressClick: () => void;
  onAgencyLogoClick?: () => void;
  onVendorTotalReviewsClick?: () => void;
  overallStarRating?: OverallStarRating;
};

const heroSection = HERO_SECTION.sticky;

const AgencyDetailsSticky = ({
  profileTier,
  agencyName,
  agencyUrl,
  imageUrl,
  address,
  isActive = false,
  isAgency = true,
  hideOfficeLocation = false,
  onAgencyAddressClick = () => undefined,
  onAgencyLogoClick = () => undefined,
  onVendorTotalReviewsClick = () => undefined,
  overallStarRating,
}: Props): JSX.Element => {
  const showRating = Boolean(overallStarRating?.totalReviews);
  return (
    <div
      css={styles.agencyDetails({
        heroSection,
        isActive,
        showRating,
      })}
      data-testid="agency-details"
    >
      {imageUrl && (
        <AgencyLogo
          heroSection={heroSection}
          profileTier={profileTier}
          agencyUrl={agencyUrl}
          imageUrl={imageUrl}
          agencyName={agencyName}
          isAgency={isAgency}
          isActive={isActive}
          onAgencyLogoClick={onAgencyLogoClick}
        />
      )}
      <div
        css={styles.body({
          heroSection,
          isActive,
        })}
        data-testid={`trade-profile-hero-${heroSection}__agency-details-body`}
      >
        <p
          css={styles.agencyName({
            heroSection,
            profileTier,
          })}
          data-testid={`trade-profile-hero-${heroSection}__name`}
        >
          {agencyName}
        </p>
        {!hideOfficeLocation && (
          <AgencyAddress
            heroSection={heroSection}
            address={address}
            onAgencyAddressClick={onAgencyAddressClick}
          />
        )}
        {showRating && (
          <AverageStarRatingAndTotal
            section={STAR_RATING_SECTION.STICKY}
            averageRating={overallStarRating?.rating ?? 0}
            totalReviews={overallStarRating?.totalReviews ?? 0}
            scrollTo
            onVendorTotalReviewsClick={onVendorTotalReviewsClick}
          />
        )}
      </div>
    </div>
  );
};
export default AgencyDetailsSticky;
